<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--7">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-6 col-6 mb-1"></div>
          <div class="col-6 pull-right">
            <div class="row">
              <label class="col-4 col-form-label form-control-label text-right">
                brand
              </label>
              <div class="col-8">
                <model-list-select
                  :list="brandCodeOption"
                  v-model="watch_brand_code"
                  option-value="value"
                  option-text="text"
                >
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @refresh-data="onRefreshData"
        >
        </vue-bootstrap4-table>
      </div>
    </div>
    <modal :show.sync="showModal" modal-classes="modal-md">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        Detail Item
        {{
          this.selectedRowPayload.merchant_id +
            "-" +
            this.selectedRowPayload.name
        }}
      </h6>
      <table class="table table-striped">
        <tbody>
          <tr>
            <td>Sub category:</td>
            <td>{{ this.selectedRowPayload.subcategory }}</td>
          </tr>
          <tr>
            <td>Sub tagline:</td>
            <td>{{ this.selectedRowPayload.tagline }}</td>
          </tr>
          <tr>
            <td>recommendations:</td>
            <td>
              <textarea
                class="form-control"
                style="height: 200px"
                readonly
                v-model="this.merchantDetail.recommendations"
              >
              </textarea>
            </td>
          </tr>
          <tr>
            <td>instructions:</td>
            <td style="">
              <textarea
                class="form-control"
                style="height: 200px"
                readonly
                v-model="this.merchantDetail.instructions"
              >
              </textarea>
            </td>
          </tr>
          <tr>
            <td>fine_print:</td>
            <td style="">
              <textarea
                class="form-control"
                style="height: 200px"
                readonly
                v-model="this.merchantDetail.fine_print"
              >
              </textarea>
            </td>
          </tr>
          <tr>
            <td>Logo Image:</td>
            <td>
              <img
                width="200px"
                class="img-thumbnail"
                :src="this.selectedRowPayload.logo_url"
              />
            </td>
          </tr>
          <tr>
            <td>Card Image</td>
            <td>
              <img
                width="200px"
                class="img-thumbnail"
                :src="this.selectedRowPayload.card_url"
              />
            </td>
          </tr>
          <tr>
            <td>Cover Image</td>
            <td>
              <img
                width="200px"
                class="img-thumbnail"
                :src="this.selectedRowPayload.cover_url"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <template slot="footer">
        <base-button type="link" class="ml-auto" @click="showModal = false"
          >Close
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import api_loyalty from "./../api/api";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  name: "merchantlist",
  data() {
    return {
      brandCodeOption: [],
      watch_brand_code: "PHFortune",
      merchantDetail: {
        recommendations: "",
        locations: {
          city: "",
          latitude: "",
          longitude: "",
          name: "",
          streetline1: "",
          streetline2: "",
        },
      },
      selectedRowPayload: {
        card_url: "",
        category: "",
        cover_url: "",
        denomination_count: "",
        details_url: "",
        has_custom: "",
        has_markup: "",
        is_virtual: "",
        location_count: "",
        logo_url: "",
        markup_rate: "",
        maximum_custom_value: "",
        merchant_id: "",
        minimum_custom_value: "",
        name: "",
        subcategory: "",
        tagline: "",
      },
      showModal: false,
      rows: [],
      columns: [
        {
          label: "ID",
          name: "merchant_id",
          sort: true,
          uniqueId: true,
        },
        {
          label: "Name",
          name: "name",
          sort: true,
        },
        {
          label: "Category",
          name: "category",
          sort: true,
        },
        {
          label: "Denomination Count",
          name: "denomination_count",
        },
        {
          label: "Min custom value",
          name: "minimum_custom_value",
          sort: true,
        },
        {
          label: "Min custom value",
          name: "maximum_custom_value",
          sort: true,
        },
      ],
      config: {
        pagination: true,
        pagination_info: true,
        num_of_visibile_pagination_buttons: 7,
        per_page: 10,
        checkbox_rows: false,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
        selected_rows_info: true,
        per_page_options: [5, 10, 20, 30],
      },
      classes: {
        table: "table-striped table bordered",
      },
    };
  },
  created() {
    this.mappingRole();
    this.onRefreshData();
  },
  methods: {
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('merchantlist')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('merchantlist')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.watch_brand_code = "PHFortune";
      }
    },
    toggleActive() {},
    onRefreshData() {
      api_loyalty.fetchAllGiveawayMerchantList(this.watch_brand_code).then((data) => {
        try {
          if(data.isSuccess) {
            this.rows = data.data;
          }
        } catch (e) {
          console.log(e);
        }
      });
    },
    onSelectRow(payload) {
      this.selectedRowPayload = payload.selected_item;
      api_loyalty
        .getMerchantDetail(this.selectedRowPayload.merchant_id, this.watch_brand_code)
        .then((data) => {
          if(data.isSuccess){
            this.merchantDetail = data.data;
          }
        });
      this.showModal = true;
    },
  },
  components: {
    VueBootstrap4Table,
    ModelListSelect,
  },
  watch: {
    watch_brand_code: function() {
      this.onRefreshData();
    },
  },
};
</script>
<style></style>
